import { createAppAsyncThunk } from '@/admin/helpers';
import { t } from '@/core/localization';
import { getErrorFromException } from '@/core/utils/errorHandling';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { enqueueSnackbar } from 'notistack';
import { stockReceiptApi } from '../stockReceipt.api';
const createSurplusReceiptTask = createAppAsyncThunk('stockReceipt/createSurplusReceiptTask', async (_blank, { getState, dispatch, rejectWithValue }) => {
    const searchId = getState().stockReceipt.uploadSurplusItemsDialog.surplusItemsPrices?.searchId;
    if (!searchId)
        return rejectWithValue('no searchId');
    try {
        const result = await dispatch(stockReceiptApi.endpoints.createSurplusReceiptTask.initiate({ searchId })).unwrap();
        const { invoiceNum, itemsCount, quantity } = result;
        enqueueSnackbar({
            variant: 'success',
            header: t('upload.surplus.items.receipt.created.successfully.title'),
            body: t('upload.surplus.items.receipt.created.successfully.body', { invoiceNum, itemsCount, quantity }),
        });
    }
    catch (error) {
        const errorMessage = getErrorFromException(error);
        dispatch(showApiErrorSnackbar({ header: t('upload.surplus.items.receipt.failed'), error }));
        return rejectWithValue(errorMessage);
    }
});
export { createSurplusReceiptTask };
